/**
 * @generated SignedSource<<c13dc0fd84556e9cf3d837f982bcbca6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SupplierAmountEstimateSource = "HETZNER" | "%future added value";
export type AssignSupplierAmountEstimateSourceInput = {
  amountEstimateSource?: SupplierAmountEstimateSource | null | undefined;
  id: string;
};
export type ConfigureSupplierDialogAssignAmountEstimateSourceMutation$variables = {
  input: AssignSupplierAmountEstimateSourceInput;
};
export type ConfigureSupplierDialogAssignAmountEstimateSourceMutation$data = {
  readonly assignSupplierAmountEstimateSource: {
    readonly amountEstimateSource: SupplierAmountEstimateSource | null | undefined;
    readonly id: string;
  };
};
export type ConfigureSupplierDialogAssignAmountEstimateSourceMutation = {
  response: ConfigureSupplierDialogAssignAmountEstimateSourceMutation$data;
  variables: ConfigureSupplierDialogAssignAmountEstimateSourceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Supplier",
    "kind": "LinkedField",
    "name": "assignSupplierAmountEstimateSource",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amountEstimateSource",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConfigureSupplierDialogAssignAmountEstimateSourceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConfigureSupplierDialogAssignAmountEstimateSourceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "678bc6f9c12442ab9fc327020dfe1839",
    "id": null,
    "metadata": {},
    "name": "ConfigureSupplierDialogAssignAmountEstimateSourceMutation",
    "operationKind": "mutation",
    "text": "mutation ConfigureSupplierDialogAssignAmountEstimateSourceMutation(\n  $input: AssignSupplierAmountEstimateSourceInput!\n) {\n  assignSupplierAmountEstimateSource(input: $input) {\n    id\n    amountEstimateSource\n  }\n}\n"
  }
};
})();

(node as any).hash = "c332d51d18fa2f17011cddfe30291705";

export default node;
